import { useState } from 'react'
import classNames from 'classnames'

import { ReactComponent as BagdeIcon } from '@/assets/icons/badge-icon.svg'
import { ReactComponent as EllipsisIcon } from '@/assets/icons/ellipsis-icon.svg'
import { ReactComponent as EyeOffIcon } from '@/assets/icons/eye-off-solid.svg'

import labelsService from '@/app-domains/labels/labels.service'
import { EditDropdownMenu } from './EditDropdownMenu/EditDropdownMenu'

import useRenderEvent from '@/core/hooks/useRenderEvent'

import dropdownService from '@/components/DropdownMenu/dropdown.service'
import commonsService from '@/services/commons.service'
import { BoxesButtons } from '../BoxesButtons/BoxesButtons'

import './LabelsButtons.scoped.sass'

function LabelButton ({ currentBoxes, label, selectedLabel, selectLabel, selectBox, selectedBox, labelPadding, totalLabels }) {
  const iconSize = { width: '18px', height: '18px' }
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuOpenedEvent, setMenuOpenedEvent] = useState(false)
  
  const toggleMenuOpen = (e) => {
    e.stopPropagation()
    if (dropdownService.isOpenedForThisTarget(e)) {
      setMenuOpened(false)
      setMenuOpenedEvent(false)
      return dropdownService.close()
    }
    
    setMenuOpenedEvent(e)
    setMenuOpened(Date.now())
  }

  useRenderEvent(['DROPDOWN:CLOSE'], () => {
    setMenuOpened(false)
    setMenuOpenedEvent(false)
  })

  return <>
    <li id={'label-button' + label.id}
    style={{ 'padding-top': labelPadding, 'padding-bottom': labelPadding }}
    className={classNames(
      {
        active: (selectedLabel?.name === 'Unlabeled' && label.name === 'Unlabeled') || selectedLabel?.id ? selectedLabel?.id === label.id : selectedLabel?.name === label.name,
        'menu-opened': menuOpened
      })} onClick={() => selectLabel(label)}>
      <div className="label-left">
        <span className='label-icon'>
          <BagdeIcon />
        </span>
        <span className='label-name' title={label.name}>
          {label.name}
        </span>
      </div>
      <div className='label-button-right-menu'>
        <div className="eye-off-icon">
          {!(label.showninfeed || (label.type === 'no-labeled' && label.isShown)) && <EyeOffIcon style={iconSize} />}
        </div>
        <div className="label-right">
          {label.boxes.length}
        </div>
        { label.role !== '' && <div className="label-button-dropdown-button">
          <EllipsisIcon onClick={toggleMenuOpen} />
          { menuOpened && <EditDropdownMenu label={label} event={menuOpenedEvent} maxLabelOrder={totalLabels - 1}/> }
        </div> }
      </div>
    </li>
    { commonsService.isMobile() && selectedLabel !== 'All' && currentBoxes.length > 0 &&
      <li className={classNames('secondary-label-menu', { hidden: selectedLabel.id !== label.id })}>
        <ul className="mb-boxes-buttons-container">
          <BoxesButtons currentBoxes={currentBoxes} selectBox={selectBox} selectedBox={selectedBox}/>
        </ul>
      </li> }
  </>
}

export function LabelsButtons ({ selectBox, selectedBox, currentBoxes, selectedLabel, selectLabel, labelPadding }) {
  const [labels, setLabels] = useState(labelsService.getLabelsList())
  useRenderEvent(['CONTAINERS:UPDATED', 'LABELS:UPDATED', 'LABELS:DELETED'], () => {
    setLabels(labelsService.getLabelsList())
  })
  return labels.sort((a, b) => a.sortindex - b.sortindex).map((label) => {
    return <LabelButton key={label.id} label={label} labelPadding={labelPadding}
      selectedLabel={selectedLabel} selectLabel={selectLabel} currentBoxes={currentBoxes}
      selectBox={selectBox} selectedBox={selectedBox} totalLabels={labelsService.getPureLabelsList().length}
      />
  })
}
